import theme from "../theme";
import { lighten } from "polished";

export const mainStyles = {
  header: {
    mx: 2
  },
  title: {
    mb: ["4px", 1],
    fontSize: ["24px", "32px"],
    lineHeight: ["32px", "40px"]
  },
  subtitle: {
    mb: [1, 0],
    color: "darkGray",
    fontSize: ["18px", "24px"]
  },
  heading: {
    color: "darkGrey",
    fontWeight: "bold",
    fontSize: 0,
    ml: 2,
    mt: 2
  }
};

export const searchBoxMobileStyles = {
  searchView: {
    flexDirection: "row",
    height: "82px",
    p: 2,
    bg: "samoyedWhite",
    position: "sticky",
    top: 0,
    zIndex: 100
  },
  searchBox: {
    flexDirection: "row",
    flex: 1,
    border: "1px solid",
    borderColor: "gray",
    borderRadius: "4px",
    p: 2,
    alignItems: "center",
    mr: 1
  },
  searchText: {
    marginLeft: "10px",
    flexGrow: 1
  },
  serviceText: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "medium"
  },
  detailsText: {
    fontSize: "14px",
    lineHeight: "14px"
  },
  btnMap: {
    width: "96px",
    backgroundColor: "inuOrange",
    borderRadius: "6px",
    justifyContent: "center"
  },
  textMap: {
    fontWeight: "medium",
    fontSize: "18px",
    color: "samoyedWhite",
    textAlign: "center"
  }
};

export const searchFiltersStyle = {
  modalContainer: {
    mt: [2, 2, 4],
    mb: 2,
    mx: [0, 0, "16px"],
    flexDirection: "column",
    gap: "16px"
  },
  modalTitle: {
    marginBottom: "16px",
    fontSize: "24px",
    lineHeight: "24px",
    fontWeight: "400"
  },
  serviceBlock: {
    flexGrow: 1,
    flexDirection: "row",
    paddingTop: "8px",
    paddingBottom: "8px"
  },
  serviceBlockWeb: {
    border: "1px solid",
    borderColor: "lightGray",
    borderRadius: "24px",
    flex: 1,
    alignItems: "center"
  },
  serviceBlockWebSelected: {
    borderColor: theme.colors.springGreen,
    backgroundColor: theme.colors.springGreen
  },
  serviceIconView: {
    justifyContent: "center",
    alignItems: "center",
    width: "56px",
    height: "56px",
    border: "1px solid",
    borderColor: "springGreen",
    borderRadius: "8px"
  },
  serviceTitle: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 300,
    color: theme.colors.springGreen
  },
  serviceDesc: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "400",
    color: "darkGray"
  },
  datesTitle: {
    flex: 1
  },
  datesContainer: {
    border: "1px solid",
    borderColor: "#ddd",
    borderRadius: "6px",
    height: "48px",
    padding: "12px",
    flexGrow: 1
  },
  datesSubblock: {
    flex: 1,
    gap: "8px",
    alignItems: "center"
  },
  datesTextPlaceholder: {
    color: "darkGray"
  },
  datesText: {
    color: "veryDarkGray"
  },
  datesButtonView: {
    marginTop: "24px",
    backgroundColor: "samoyedWhite",
    justifyContent: "space-between"
  },
  datesButton: {
    width: "100%",
    marginRight: "auto",
    marginLeft: "auto"
  },
  moreDogsContainer: {
    BorderTop: "1px solid",
    borderColor: "gray",
    paddingVertical: "16px",
    marginTop: "16px"
  },
  moreDogsView: {
    flexDirection: "row",
    alignItems: "center"
  },
  iconView: {
    width: "40px",
    height: "40px",
    border: "1px solid springGreen",
    borderColor: theme.colors.springGreen,
    borderRadius: "25px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "12px"
  },
  sizeIconView: {
    justifyContent: "center",
    alignItems: "center"
  },
  sizeIcon: {
    width: "24px",
    height: "24px",
    border: "1px solid",
    borderColor: theme.colors.inuOrange,
    borderRadius: "24px",
    justifyContent: "center",
    alignItems: "center"
  },
  iconText: {
    ...theme.text.h3
  }
};

export const boxFiltersWebStyles = {
  container: {
    my: 3,
    mx: "auto",
    py: 1,
    px: 3,
    maxWidth: "fit-content",
    minWidth: "700px",
    border: "1px solid",
    borderColor: "gray",
    borderRadius: "6px",
    justifyContent: "center"
  },
  subContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    cursor: "pointer",
    ":hover h4": {
      color: "springGreen"
    },
    ":hover p": {
      color: "gray"
    }
  },
  datesContainer: {
    ":hover h4": {
      color: "springGreen"
    },
    ":hover p": {
      color: "gray"
    }
  },
  subTitle: {
    color: "gray"
  },
  subTitleContent: {
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  divider: {
    width: "1px",
    bg: "gray",
    margin: "0 16px"
  },
  flexIcon: {
    gap: "8px",
    alignItems: "center"
  },
  arrowIcon: {
    transform: "rotate(180deg)",
    alignItems: "center",
    margin: "0 16px"
  },
  dropDownContainer: {
    flexDirection: "column",
    position: "absolute",
    backgroundColor: "samoyedWhite",
    border: "1px solid",
    borderColor: "gray",
    borderRadius: "0 0 6px 6px",
    zIndex: 1
  },
  serviceView: {
    mt: "3px",
    ml: "-25px"
  },
  locationView: {
    mt: "3px",
    ml: "-88px",
    p: "24px"
  },
  datesView: {
    mt: "55px",
    ml: "-235px",
    p: "0 32px 24px 32px",
    width: "740px"
  },
  dogsView: {
    width: "420px",
    p: "16px 32px",
    mt: "3px",
    ml: "-210px"
  },
  restFiltersView: {
    p: "16px 32px",
    mt: "20px",
    right: ["9%", "9%", "9%", "24%"],
    width: "456px"
  },
  dropDownRow: {
    alignItems: "center",
    p: "16px 20px",
    gap: "8px",
    ":hover": {
      bg: lighten(0.3, theme.colors.springGreen)
    }
  }
};

export const searchBenefitsStyles = {
  container: {
    color: "labradorBlack",
    pt: [1, 2],
    pb: [2, 3],
    borderBottom: "1px solid lightgray"
  },
  text: {
    px: 2,
    pb: 2,
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 300,
    color: "labradorBlack"
  },
  infoContainer: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    px: 2
  }
};
